import { render, staticRenderFns } from "./DHV.vue?vue&type=template&id=a308660e&scoped=true"
import script from "./DHV.vue?vue&type=script&lang=js"
export * from "./DHV.vue?vue&type=script&lang=js"
import style0 from "./DHV.vue?vue&type=style&index=0&id=a308660e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a308660e",
  null
  
)

export default component.exports